import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";
import i18n from "../i18n";

const CLASSES_BASE = `${apiBaseUrl}/api/lessons/classes`;

async function request(
  path = "/",
  { accessToken, method = "GET", body, params } = {},
) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Accept-Language": getStoredLanguage(),
  };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const queryParams = params
    ? { ...params, lang: getStoredLanguage() }
    : { lang: getStoredLanguage() };
  const queryString = `?${new URLSearchParams(queryParams).toString()}`;

  const response = await fetch(`${CLASSES_BASE}${path}${queryString}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || i18n.t("errors.fetchFailed");
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function fetchClasses({ accessToken, params } = {}) {
  return request("/", { accessToken, params });
}

export function createClassGroup(accessToken, payload) {
  return request("/", {
    accessToken,
    method: "POST",
    body: payload,
  });
}

export function updateClassGroup(accessToken, classId, payload) {
  return request(`/${classId}/`, {
    accessToken,
    method: "PATCH",
    body: payload,
  });
}

export function deleteClassGroup(accessToken, classId) {
  return request(`/${classId}/`, {
    accessToken,
    method: "DELETE",
  });
}
